import { Input, Space } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import TipTap from '../TipTap';
import { createSection } from '../../constants';

interface ActivityTypeProps {
  setData: (path: string, value: any) => void;
  data: any;
  riskDriverId?: string;
  contentItemId?: string;
  sectionKey: string;
  dataKey: string;
  readonly?: boolean;
}
const ActivityType: React.FC<ActivityTypeProps> = ({
  setData,
  data,
  riskDriverId,
  contentItemId,
  sectionKey,
  dataKey,
  readonly = false
}) => {
  const info = useMemo(() => {
    if (dataKey === 'riskDrivers') {
      return (
        data?.riskDrivers
          ?.find((driver: any) => driver.id === riskDriverId)
          ?.data?.find((item: any) => item.id === contentItemId)?.data || ''
      );
    } else if (dataKey === 'description') {
      return data.description.find((item: any) => item.id === contentItemId)?.data || '';
    }
    return '';
  }, [dataKey, data?.riskDrivers, data.description, riskDriverId, contentItemId]);

  const handleChange = (value: any, key: string) => {
    if (readonly) return; // Prevent changes in readonly mode
    if (dataKey === 'riskDrivers') {
      const updatedRiskDrivers = data.riskDrivers.map((driver: any, i: number) => {
        if (driver.id === riskDriverId) {
          driver.data.forEach((item: any, j: number) => {
            if (item.id === contentItemId) {
              item.data = { ...item.data, [key]: value };
            }
          });
          return driver;
        }
        return driver;
      });
      setData(`${sectionKey}.riskDrivers`, updatedRiskDrivers);
    } else {
      const updatedDescription = data.description.map((item: any) => {
        if (item.id === contentItemId) {
          item.data = { ...item.data, [key]: value };
        }
        return item;
      });
      setData(`${sectionKey}.description`, updatedDescription);
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Input
        value={info?.title}
        disabled={readonly}
        onChange={(e) => handleChange(e.target.value, 'title')}
        placeholder="Chart title (do not include figure number)"
      />
      <Input
        value={info?.id}
        disabled={readonly}
        onChange={(e) => handleChange(e.target.value.replace(/\s/g, ''), 'id')}
        placeholder="Unique Id (for tech team use only)"
      />
      <TipTap
        value={info?.description}
        readonly={readonly}
        onChange={(value) => handleChange(value, 'description')}
        MAX_CHARS={850}
      />
    </Space>
  );
};

export default ActivityType;
